<template>
  <Card style="width: 20em;max-height: 440px;min-height: 440px;text-align:center">
    <template #header>
      <img
        alt="user header"
        :src="linkIcon"
        style="height:100px;width:auto;margin-top:20px"
      />
    </template>
    <template #title>
      {{titulo}}
    </template>
    <template #subtitle style="font-size: 12px;">
      <span style="font-size: 12px;">{{ $t("messages.lastUpdate") }}: {{formatDate(ultimaActualizacion)}}</span>      
    </template>
    <template #content>
      <a :href="`${urlFiles}${linkFile}`" target="blank">
        <Button icon="pi pi-check" :label="$t('messages.download')" class="p-mb-3" name="descargar"/></a>
      <p>
        {{resumen.substr(0,250)}}
      </p>
    </template>
    <template #footer>        
    </template>
  </Card>
</template>

<script>
import InfoService from "../service/informacion.service";
export default {
    data() {
      return {
          infoService:null,
          urlFiles:null
      }
  },
  created(){
      this.urlFiles = process.env.VUE_APP_API_FILES;
      this.infoService=new InfoService()
  },
  props: {
    titulo: {
      type: String,
      default: '',
    },
    ultimaActualizacion: {
      type: String,
      default: '',
    },
    resumen: {
      type: String,
      default: '',
    },
    linkFile: {
      type: String,
      default: '',
    },
    linkIcon: {
      type: String,
      default: '',
    },
  },
  methods: {
      formatDate(fecha){
          return new Date(fecha).toLocaleDateString('en-GB')
      }
  },
};
</script>

<style scoped></style>
